import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Formik, Form } from "formik"
import { InputAdornment, IconButton, Box, Typography } from "@material-ui/core"
import * as Yup from "yup"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import ReusableFormControl from "components/ReusableFormControl"
import { resetPassword } from "actions/user"
// import { closeResetPasswordDialog } from "actions/reset-password-dialog"
import { openSnackBar } from "actions/snack-bar"

const PasswordSchema = Yup.object().shape({
  password: Yup.string().required("Required")
})

const NewPassword = ({
  classes,
  formRef,
  setWorking,
  handleStep,
  resetData,
  handleClose
}) => {
  const dispatch = useDispatch()
  const [showPassword, setShowPassword] = useState(false)
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleSubmit = values => {
    setWorking(true)
    const data = { ...values, ...resetData }
    dispatch(resetPassword(data))
      .then(res => {
        // console.log(res)
        setWorking(false)
        handleClose()
        dispatch(openSnackBar({ message: "Password has been updated." }))
      })
      .catch(error => {
        setWorking(false)
        handleClose()
        dispatch(openSnackBar({ message: "Error updating password." }))
      })
    // console.log(values)
  }
  return (
    <Box className={classes.newPasswordContainer}>
      <Formik
        innerRef={formRef}
        initialValues={{
          password: ""
        }}
        validationSchema={PasswordSchema}
        onSubmit={values => {
          handleSubmit(values)
        }}
      >
        {formikProps => (
          <Box className={classes.passwordInputContainer}>
            <Form>
              <Typography>Please enter your new password.</Typography>
              <ReusableFormControl
                name="password"
                label="New Password"
                formikProps={formikProps}
                inputProps={{
                  type: showPassword ? "text" : "password",
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                      >
                        {showPassword ? (
                          <Visibility color="primary" />
                        ) : (
                          <VisibilityOff color="primary" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Form>
          </Box>
        )}
      </Formik>
    </Box>
  )
}

export default withStyles(styles)(NewPassword)



// WEBPACK FOOTER //
// ./src/dialogs/ResetPassword/steps/NewPassword/index.jsx